import { render, staticRenderFns } from "./SnSerialManageEdit.vue?vue&type=template&id=477648b2&scoped=true&"
import script from "./SnSerialManageEdit.vue?vue&type=script&lang=js&"
export * from "./SnSerialManageEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477648b2",
  null
  
)

export default component.exports